import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

interface LineChartProps {
  data: any[];
  lines: string[];
  colors: [string, string, string][];
}

const CustomXAxisTick = ({ x, y, payload }: any) => {
  const [date, time] = payload.value.split("T");
  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={10}
        dy={20} // 👈 Push label lower from the axis line
        textAnchor="middle"
        fill="#666"
        fontSize={12} // 👈 Smaller font
      >
        <tspan x={0} dy="0">
          {date}
        </tspan>
        <tspan x={0} dy="12">
          {time}
        </tspan>{" "}
        {/* More padding between lines */}
      </text>
    </g>
  );
};

const MultiLineChart: React.FC<LineChartProps> = ({ data, lines, colors }) => {
  return (
    <div className="w-[900px] md:w-full h-[450px] bg-white shadow-lg p-4 rounded-lg">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={data}
          margin={{ top: 20, right: 30, left: 20, bottom: 30 }} // เพิ่ม bottom เพื่อเว้นที่ให้ legend
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" tick={<CustomXAxisTick />} />
          <YAxis />
          <Tooltip />

          {/* ขยับ legend ลงด้วย position + translate */}
          <Legend
            verticalAlign="bottom"
            align="center"
            wrapperStyle={{
              transform: "translateY(20px)", // ขยับลงอีก
            }}
          />

          {lines.map((line, index) => (
            <Line
              key={line}
              type="monotone"
              dataKey={line}
              stroke={colors[index][2]}
              strokeWidth={2}
              dot={false}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MultiLineChart;
